export const TENANT_AUTH_LS_KEY = "maeiz-tenant-auth";
export const TENANT_THEME_LS_KEY = "maeiz-tenant-theme";
export const TENANT_SIDEBAR_LS_KEY = "maeiz-tenant-sidebar";
export const TENANT_LANG_LS_KEY = "maeiz-tenant-lang";
export const TENANT_LANGUAGE_STORE_LS_KEY = "maeiz-tenant-language-store";
export const TENANT_CURRENCY_LS_KEY = "maeiz-tenant-currency";
